import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {DivDataTable, DivFilter} from "./styles";

import {EStatus, IRequestUserTO, IResponseUserTO} from "../../../models/user";
import {UserService} from "../../../services/user-service";
import DataTable from "../../../components/data-table";
import {ButtonLogin} from "../../auth/login/styles";
import PageContainer from "../../../components/page-container";
import PageTitle from "../../../components/page-title";
import DataTablePagination from "../../../components/table-pagination";
import {Order} from "../../../interfaces/table-head";
import { IFilter } from "../../../models/filter";
import Filter from "../../../components/filter";
import { EFilterColumnsUser } from "../../../models/user";

export default function ListUser() {

  const navigate = useNavigate();

  const [data, setData] = useState<IResponseUserTO[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const [filters, setFilters] = useState<IFilter[]>([]);

  const [loading, setLoading] = useState(true);

  const getUsers = async () => {
    const objeto: IRequestUserTO = {
    };

    for (const filter of filters) {
      if (filter.field === "Nome") {
        objeto.name = filter.value as string;
      }
      if (filter.field === "Usuário") {
        objeto.username = filter.value as string;
      }
      if (filter.field === "Email") {
        objeto.email = filter.value as string;
      }
      if (filter.field === "Status") {
        objeto.status = filter.value as EStatus;
      }
    }

    setLoading(true);
    const response = await UserService
      .getAllUsers({
        page: page,
        size: rowsPerPage,
        sort: orderBy + "," + order
      },
        objeto
      );
    if (typeof response?.content === "object") {
      setData(response.content);
      setCount(response.totalElements);
    }
    setLoading(false);
  };

  const handleClick = () => {
    navigate("/usuarios/cadastrar");
  };

  useEffect(() => {
    getUsers();
  }, [page, rowsPerPage, orderBy, order, filters]);

  return (
    <PageContainer>
      <PageTitle>Lista de usuários</PageTitle>
      <DivFilter>
        <Filter filters={filters} setFilters={setFilters} fields={[
          {
            columnName: EFilterColumnsUser.NAME,
            valueType: "text"
          },
          {
            columnName: EFilterColumnsUser.EMAIL,
            valueType: "text"
          },
          {
            columnName: EFilterColumnsUser.USER,
            valueType: "text"
          },
          {
            columnName: EFilterColumnsUser.STATUS,
            valueType: "select",
            options: [{
              label: "Ativo",
              value: "ACTIVE"
            },
            {
              label: "Inativo",
              value: "INACTIVE"
            },
            {
              label: "Pendente",
              value: "PENDING"
            },
            {
              label: "Bloqueado",
              value: "BLOCKED"
            }]
          }
        ]}></Filter>
        <ButtonLogin onClick={handleClick}> Cadastrar </ButtonLogin>
      </DivFilter>
      <DivDataTable>
        <DataTable setOrderBy={setOrderBy}
                   setOrder={setOrder}
                   order={order}
                   orderBy={orderBy}
                   update={getUsers}
                   data={data}
                   loading={loading}/>
      </DivDataTable>
      <DataTablePagination page={page} setPage={setPage} setRowsPerPage={setRowsPerPage}
                           rowsPerPage={rowsPerPage} count={count}/>
    </PageContainer>
  );
}
